import 'css-chunksrc/client/pages/documentsPage/documentsPage/styles.scss';export default {
  "documentsPage": "_documentsPage_1nk64_1",
  "header": "_header_1nk64_9",
  "content": "_content_1nk64_16",
  "main": "_main_1nk64_24",
  "dropPreview": "_dropPreview_1nk64_33",
  "dragContent": "_dragContent_1nk64_41",
  "documents": "_documents_1nk64_1",
  "list": "_list_1nk64_54",
  "docViewer": "_docViewer_1nk64_64",
  "loader": "_loader_1nk64_72",
  "dropZone": "_dropZone_1nk64_92"
};